import { render, staticRenderFns } from "./RecentTrades.vue?vue&type=template&id=209c44f2&scoped=true&"
import script from "./RecentTrades.vue?vue&type=script&lang=js&"
export * from "./RecentTrades.vue?vue&type=script&lang=js&"
import style0 from "./RecentTrades.vue?vue&type=style&index=0&id=209c44f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209c44f2",
  null
  
)

export default component.exports